
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'RadioGroupInput',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array as PropType<Record<string, string>[]>,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modelValue: {
      get(): string | number {
        return this.value
      },
      set(value: string | number) {
        this.$emit('input', value)
      }
    }
  }
})
